import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-body-container',
  templateUrl: './page-body-container.component.html',
  styleUrls: ['./page-body-container.component.scss'],
  standalone: false,
})
export class PageBodyContainerComponent {}
